"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "appiano-sulla-strada-del-vino": {
    "4445d685": [{
      "hkey": "46a36d86",
      "slug": "appiano-sulla-strada-del-vino",
      "name": "Appiano sulla strada del vino",
      "primary": true,
      "skipSearch": false
    }],
    "gaido": [{
      "hkey": "46a36d86",
      "slug": "appiano-sulla-strada-del-vino",
      "name": "Appiano sulla strada del vino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;